import { createContext, useContext, useState, ReactNode } from 'react';

export type Platform = 'ats' | 'business' | 'admin' | 'finance' | 'education';

interface PlatformContextType {
  currentPlatform: Platform;
  setPlatform: (platform: Platform) => void;
}

const PlatformContext = createContext<PlatformContextType | undefined>(undefined);

export function PlatformProvider({ children }: { children: ReactNode }) {
  const [currentPlatform, setPlatform] = useState<Platform>('admin');

  return (
    <PlatformContext.Provider value={{ currentPlatform, setPlatform }}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform() {
  const context = useContext(PlatformContext);
  if (!context) {
    throw new Error('usePlatform must be used within PlatformProvider');
  }
  return context;
}
